import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController, AlertController } from 'ionic-angular';
import { SolicitacaoContatoModel } from './solicitacao-contato.modelview';
import { SolicitacaoContatoPageProvider } from './solicitacao-contato.provider';
import { Validators, FormBuilder } from '@angular/forms';
import * as moment from 'moment';


/**
 * Generated class for the SolicitacaoContatoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-solicitacao-contato',
  templateUrl: 'solicitacao-contato.html',
})
export class SolicitacaoContatoPage {
  isBrowser = false
  model: SolicitacaoContatoModel = new SolicitacaoContatoModel()

  form = {}

  today;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private toastCtrl: ToastController,
    private formBuilder: FormBuilder,
    public loadingCtrl: LoadingController,
    private alertController: AlertController,
    public solicitacaoContatoPageProvider: SolicitacaoContatoPageProvider) {

    this.today = new Date().toISOString()

    this.form = formBuilder.group({
      forma_contato: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
      data: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
      hora: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
      especialidade: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
    });

    this.isBrowser = this.navParams.get("isBrowser")
    this.model.formas_contato = ["Telefone", "Email"]

    this.solicitarListas()
    this.solicitarDadosUsuario()

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SolicitacaoContatoPage');
  }

  solicitarContato() {

    if (this.validationDate()) {
      this.showComercialTimeError()
      return;
    }

    let loading = this.loadingCtrl.create({
      content: 'Cadastrando...'
    });
    loading.present()

    this.solicitacaoContatoPageProvider.solicitarContato(this.model).subscribe(() => {
      loading.dismiss().then(() => {
        let toast = this.toastCtrl.create({
          message: "Contato solicitado com sucesso!",
          duration: 5000,
          position: 'bottom'
        });
        toast.present()
      })
    }, err => {
      loading.dismiss().then(() => {
        let toast = this.toastCtrl.create({
          message: err.message,
          showCloseButton: true,
          position: 'bottom'
        });
        toast.present()
      })
    })
  }

  solicitarListas() {
    let loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    loading.present()

    this.solicitacaoContatoPageProvider.requestLists().subscribe((data) => {
      loading.dismiss()
      this.model.especialidades = data.especialidades_medico
    }, err => {
      loading.dismiss()
    })
  }

  solicitarDadosUsuario() {
    this.solicitacaoContatoPageProvider.getUserData().subscribe(user => {
      this.model.especialidade = user.acf.especialidades_medico
      this.model.forma_contato = user.acf.opcao_contato
    })
  }


  validationDate() {

    let date = moment(this.model.data)

    if (date.weekday() == 0 || date.weekday() == 6) {
      return true
    }

    let hour = moment(this.model.hora)

    if (hour.hour() < 8 || date.hour() > 17) {
      return true
    }

    return false;

  }

  showComercialTimeError() {
    let alert = this.alertController.create({
      title: 'Data ou hora invalida',
      subTitle: 'Selecione uma data em dia útil e horario comercial',
      buttons: ['Fechar']
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/solicitacao-contato/solicitacao-contato.ts